<template>
  <v-chip
    small
    dark
    :color="chipColor"
    style="position: absolute; right: 8px; top: 8px; z-index: 8;"
  >
    {{ chipText }}
  </v-chip>
</template>

<script>
export default {
  props: {
    chipText: {
      type: String,
      default: 'All Business Entity'
    },
    chipColor: {
      type: String,
      default: 'primary'
    }
  }
}
</script>
